import type { PreviewTableStateType } from "Pages/ImportWizard/model";
import { atom } from "recoil";

export const previewTableState = atom<PreviewTableStateType>({
  key: "ImportFile_previewTableState",
  default: {
    Rows: [],
    ShowXlsWarning: false,
    loading: false,
  },
});
